import { render, staticRenderFns } from "./FechaInicio.vue?vue&type=template&id=27733ec4"
import script from "./FechaInicio.vue?vue&type=script&lang=js"
export * from "./FechaInicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports